import { continentsForCountry, countriesForContinent } from "@studyportals/static-domain-data/continents/continent-country-mapping";

export const getContinentsForCountry = (countryId: string): string[] | undefined => {
	return continentsForCountry(countryId);
};

export const getCountriesForContinent = (continentId: string): string[] => {
	return countriesForContinent(continentId);
};
